import { createFileRoute, redirect } from "@tanstack/react-router";

// /fonts/* utilities moved to /font-generator/*. 301 each through, preserving slug.
export const Route = createFileRoute("/fonts/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/font-generator/$slug", params: { slug: params.slug }, statusCode: 301 });
  },
});
